/* eslint import/prefer-default-export: 0 */

export const isSideNavOpen = state => state.sideNav.isOpen;
